/** Contact information for Optum Behavioral Health Care. */

export const PHONE_NUMBER = "1-877-622-0013";
export const PHONE_NUMBER_HOURS = "9am - 5pm (local time)";
export const EAP_PHONE_NUMBER = "1-866-287-1802";
